// Based on values in API docs: https://developers.giftya.com/#tag/Gifts-Management-Operations/operation/get-gift
export const EGIFT: string = 'EGIFT'
export const CARD_LINK: string = 'CARD_LINK'
export const VISA: string = 'VISA'
export const EXCHANGE: string = 'EXCHANGE'
export const REGIFT: string = 'REGIFT'
export const SELECT_MERCHANT: string = 'SELECT_MERCHANT'
